<div class="endpoint-container" [ngClass]="endpointConfiguration?.class">
  <span class="endpoint-title label">{{ endpointConfiguration.title }}</span>
  <div
    class="sub-container"
    [ngClass]="{
      disabled:
        editMode ||
        selectedEndpoints[0]?.testFrom == 'originator' ||
        selectedEndpoints[0]?.testFrom == 'destination'
    }"
  >
    <div class="label">
      <i [ngClass]="endpointConfiguration.icon"></i>
      <div *ngIf="!selectedEndpoints.length" class="label__description">
        <span class="select">{{ endpointConfiguration.label }}</span>
        <div>{{ endpointConfiguration.message }}</div>
      </div>
      <div [ngClass]="{ 'location-detail': editMode }">
        <div class="location-details" *ngIf="selectedEndpoints.length == 1">
          <span class="fixed-label">{{ endpointInfo.title }}</span>
          <span class="fixed-label location-label">{{ endpointInfo.label }}</span>
          <span class="fixed-label location-label light-gray">{{ endpointInfo.subLabel }}</span>
          <span class="fixed-label location-label">{{ endpointInfo.subLabel1 }}</span>
        </div>
        <div class="location-details total_destination" *ngIf="selectedEndpoints.length > 1">
          {{ selectedEndpoints.length + selectionMessage }}
        </div>
      </div>

      <div
        *ngIf="!editMode"
        class="view-device"
        title="{{ disabled && disabledMessage ? disabledMessage : '' }}"
      >
        <a
          (click)="viewEdpoints()"
          [ngClass]="{
            hideChange:
              selectedEndpoints[0]?.testFrom == 'originator' ||
              selectedEndpoints[0]?.testFrom == 'destination',
            disabled: disabled
          }"
          >{{ selectedEndpoints.length ? 'Change' : 'View' }}</a
        >
      </div>
    </div>
  </div>
  <div *ngIf="warningMessage" class="warning-msg">
    {{ warningMessage }}
  </div>
</div>
